import React from 'react';
import { Link } from 'react-router-dom';
import { FaCog, FaMicrochip, FaCloud, FaBroadcastTower, FaNetworkWired, FaTools, FaBox } from 'react-icons/fa';
import './MinimalistHomePage.css';

function MinimalistHomePage() {
  const services = [
    {
      icon: <FaCog />,
      title: 'PLC & HMI Programming',
      description: 'Expert PLC & HMI programming in multiple languages (Structured Text, Ladder, Function Block Diagram, Sequential Function Chart) for industrial automation and process control. Multi Vendor support.',
      details: ['Siemens S7 PLCs', 'Allen-Bradley PLCs', 'Mitsubishi PLCs', 'Drives', 'LabVIEW', 'Wonderware']
    },
    {
      icon: <FaMicrochip />,
      title: 'Microchip Development',
      description: 'Advanced microcontroller development and embedded systems design for specialized industrial applications.',
      details: ['ARM Cortex', 'Espressif', 'PCB Design & Assembly', 'Real-time Systems', 'Custom Firmware', 'Power Optimization']
    },
    {
      icon: <FaCloud />,
      title: 'Cloud Computing',
      description: 'Cloud infrastructure solutions for data analytics, remote monitoring, and scalable industrial applications.',
      details: ['AWS Integration', 'Real-time Analytics', 'Secure Data Handling', 'Scalable Architecture']
    },
    {
      icon: <FaBroadcastTower />,
      title: 'IoT Devices',
      description: 'IoT device development and integration for smart factory automation and predictive maintenance.',
      details: ['Sensor Networks', 'MQTT Protocols', 'Edge Computing', 'Device Management']
    },
    {
      icon: <FaNetworkWired />,
      title: 'Networks',
      description: 'Advanced networking solutions for industrial communication and device connectivity across diverse protocols and standards.',
      details: ['WiFi & Bluetooth LE', 'Zigbee', 'RS485/RS232', 'Modbus ASCII/RTU', 'MTConnect', 'CANBus', 'Ethernet/IP', 'Profinet', 'OPC UA','CC-Link', 'Custom Protocols']
    },
    {
      icon: <FaBox />,
      title: 'Industrial Panels & Hardware',
      description: 'Complete electrical panel design, build, and installation services. From custom control enclosure design and schematic creation to on-site installation and refurbishment of existing systems.',
      details: ['Control Panel Design', 'Electrical Schematics', 'Custom Enclosure Build', 'Panel Assembly & Wiring', 'On-Site Installation', 'System Refurbishment', 'Safety Compliance Testing']
    },
    {
      icon: <FaTools />,
      title: 'Support & Breakdown Services',
      description: 'Rapid breakdown support and maintenance for industrial machines. 24/7 on-call availability, with multiskilled capabilities for comprehensive repairs.',
      details: ['24/7 On-Call Support', 'Emergency Breakdown Response', 'Multiskilled Repairs', 'Preventive Maintenance', 'Machine Diagnostics', 'Field Service']
    }
  ];

  return (
    <main>
      {/* Hero Section */}
      <section className="hero">
        <div className="hero-content">
          <h2>Industrial Automation Solutions</h2>
          <p>Transforming Industry with Cutting-Edge Automation Technology</p>
          <div className="hero-buttons">
            <Link to="/contact" className="btn btn-primary">Get Started</Link>
            <a href="#services" className="btn btn-secondary">Explore Services</a>
          </div>
        </div>
      </section>

      {/* Services Section */}
      <section id="services" className="services">
        <div className="container">
          <div className="section-header">
            <h2>Our Services</h2>
            <p className="section-tagline">Comprehensive solutions for modern manufacturing</p>
          </div>
          
          <div className="services-grid">
            {services.map((service, index) => (
              <div key={index} className="service-card">
                <div className="service-top">
                  <div className="service-icon">{service.icon}</div>
                  <h3>{service.title}</h3>
                </div>
                <p className="service-description">{service.description}</p>
                <ul className="service-details">
                  {service.details.map((detail, i) => (
                    <li key={i}>{detail}</li>
                  ))}
                </ul>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* About Section */}
      <section id="about" className="about">
        <div className="container">
          <div className="about-wrapper">
            <h2>About NAK Engineering</h2>
            <div className="about-text">
              <p>NAK ENGINEERING LTD is a leading provider of industrial automation services, specializing in innovative solutions for modern manufacturing and industrial processes.</p>
              <p>With 18+ Years of expertise in PLC programming, microchip development, cloud computing, and IoT to deliver comprehensive automation solutions that enhance efficiency, reduce costs, and improve productivity.</p>
              <p>NAK ENGINEERING LTD is dedicated to understanding your unique challenges and providing tailored solutions that drive your business forward.</p>
            </div>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="cta">
        <div className="container">
          <h2>Ready to Transform Your Operations?</h2>
          <p>Let's discuss how we can help automate your industrial processes</p>
          <Link to="/contact" className="btn btn-primary btn-large">Contact Us</Link>
        </div>
      </section>
    </main>
  );
}

export default MinimalistHomePage;
